import React, { Component } from 'react';
import DropdownField from 'components/DropdownField';

import countries from 'data/countries.json';
import moment from 'moment-timezone';
import { Field } from 'redux-form';
import { timezoneDisplayName } from 'utils/timezoneUtils';

import TextField from './TextField';

import './style.css';

class GeneralInformation extends Component {
  renderTimezoneSuggestion() {
    const guessedTimezone = moment.tz.guess();
    const areTimezonesDifferent = this.props.curTimezone !== guessedTimezone;
    if (areTimezonesDifferent) {
      return (
        <div className="timezone-suggestion">
          <button
            type="button"
            className="btn btn-primary btn-sm btn-blue btn-cursor"
            onClick={() => this.props.selectDetectedTimezone(guessedTimezone)}
          >
            Select Current
          </button>
          {this.props.timezones && (
            <strong>{timezoneDisplayName(guessedTimezone, this.props.timezones)}</strong>
          )}
        </div>
      );
    }

    return null;
  }

  render() {
    return (
      <div className="teacher-settings-profile__section teacher-profile-information mb-4 p-4 p-md-4 p-lg-5">
        <div className="teacher-profile-information__content">
          <h4 className="mb-4">General Information</h4>

          <Field name="givenName" component={TextField} type="text" label="First Name" />

          <Field name="familyName" component={TextField} type="text" label="Last Name" />

          <Field
            name="information.countryISO"
            component={DropdownField}
            options={countries}
            label="Country"
          />

          <Field name="information.city" component={TextField} type="text" label="City" />

          <Field
            name="information.timezone"
            component={DropdownField}
            options={this.props.timezones || []}
            label="Timezone"
          />
          {this.renderTimezoneSuggestion()}

          <Field name="email" disabled component={TextField} type="email" label="Email" />

          <Field name="skypeName" component={TextField} type="text" label="Skype Username" />

          <Field
            name="information.description"
            component={TextField}
            label="About"
            multiline
          />
        </div>
      </div>
    );
  }
}

export default GeneralInformation;



// WEBPACK FOOTER //
// ./src/pages/teacher/Settings/Profile/GeneralInformation/index.js